import React, { useState } from 'react';
// @ts-ignore
import house from '../../../assets/audio/house_master.mp3';
// @ts-ignore
import edge from '../../../assets/audio/edge_unmastered.mp3';
// @ts-ignore
import dnb from '../../../assets/audio/break.mp3';
// @ts-ignore
import dnbDrums from '../../../assets/audio/dnb_drop_drums.mp3';
import houseProject from '../../../assets/pictures/projects/audio/houseProject.png';
import dnbDrumsProject from '../../../assets/pictures/projects/audio/dnbDrumsProject.png';
import { MusicPlayer } from '../../general';

export interface MusicProjectsProps {}

const MusicProjects: React.FC<MusicProjectsProps> = (props) => {
    const [currentSong, setCurrentSong] = useState<string>('');

    return (
        <div className="site-page-content">
            <h1>Music & Sound</h1>
            <h3>texto aq</h3>
            <br />
            <div className="text-block">
                <p>
                texto aq
                </p>
                <br />
                <p>
                texto aq
                </p>
                <br />
                <p>
                texto aq
                </p>
            </div>
            <h2>texto aq</h2>
            <br />
            <p>
            texto aq
            </p>
            <br />
            <p>
            texto aq
            </p>
            <br />

            <MusicPlayer
                src={house}
                title="Timeless"
                subtitle="Henry Heffernan - 2022"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />

            <br />
            <br />
            <div className="captioned-image">
                <img src={houseProject} alt="" />
                <p>
                    <sub>
                        <b>Figure 1:</b> texto aq
                    </sub>
                </p>
            </div>
            <p>
            texto aq
            </p>
            <br />
            <p>
            texto aq
            </p>
            <br />
            <h2>texto aq</h2>
            <br />
            <p>
            texto aq
            </p>
            <br />
            <MusicPlayer
                src={edge}
                title="Edge [W.I.P.]"
                subtitle="Henry Heffernan - 2021"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />
            <br />
            <p>
            texto aq
            </p>
            <br />
            <h2>My love for Drum & Bass</h2>
            <br />
            <p>
            texto aq
            </p>
            <br />
            <p>
            texto aq
            </p>
            <br />
            <MusicPlayer
                src={dnb}
                title="Taicode [Demo 3D]"
                subtitle="Casa de Software - 2019/2022"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />
            <br />
            <p>
            texto aq
            </p>
            <br />
            <MusicPlayer
                src={dnbDrums}
                title="Break [Drums and Sub]"
                subtitle="Henry Heffernan - 2019/2022"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />
            <br />
            <div className="captioned-image">
                <img src={dnbDrumsProject} alt="" />
                <p>
                    <sub>
                        <b>Figure 2:</b> texto aq
                    </sub>
                </p>
            </div>
            <br />
            <p>
            texto aq
            </p>
            <br />
            <h2>texto aq</h2>
            <br />
            <p>
            texto aq
            </p>
            <br />
            <p>
            texto aq
            </p>
            <br />
        </div>
    );
};

// const styles: StyleSheetCSS = {};

export default MusicProjects;
